import { AppShell } from './AppShell';
import { peicarLogo2vector } from '../../../Assets/Images';

const ADMIN_NAV_GROUPS = [
    {
        label: 'Operación',
        items: [
            { path: '/admin/dashboard', label: 'Dashboard', icon: 'pi pi-th-large' },
            { path: '/admin/gestion-usuarios', label: 'Gestión de Usuarios', icon: 'pi pi-users' },
            { path: '/admin/usuarios', label: 'Usuarios', icon: 'pi pi-users' },
            { path: '/admin/cotizaciones', label: 'Cotizaciones', icon: 'pi pi-file' },
            { path: '/admin/vencimientos', label: 'Vencimientos', icon: 'pi pi-bell' },
            { path: '/admin/cartera', label: 'Cartera', icon: 'pi pi-credit-card' },
            { path: '/admin/buro', label: 'Buró', icon: 'pi pi-file-edit' },
        ],
    },
    {
        label: 'Configuración',
        items: [
            { path: '/admin/valores-residuales', label: 'Valores residuales', icon: 'pi pi-cog' },
            { path: '/admin/tasas-financieras', label: 'Tasas y comisiones', icon: 'pi pi-percentage' },
            { path: '/admin/parametros-gestoria', label: 'Parámetros gestoría', icon: 'pi pi-cog' },
            { path: '/admin/direccion-placas', label: 'Dirección por placas', icon: 'pi pi-cog' },
            { path: '/admin/contrasena', label: 'Contraseña', icon: 'pi pi-cog' },
            { path: '/admin/clave-cotizador', label: 'Clave cotizador', icon: 'pi pi-cog' },
        ],
    },
];

const ADMIN_ROUTE_TITLES = {
    dashboard: 'Dashboard',
    cotizaciones: 'Cotizaciones',
    usuarios: 'Usuarios',
    'gestion-usuarios': 'Gestión de usuarios',
    vencimientos: 'Vencimientos',
    cartera: 'Cartera / Cobranza',
    buro: 'Buró de Crédito',
    'valores-residuales': 'Valores residuales',
    'tasas-financieras': 'Tasas y comisiones',
    'parametros-gestoria': 'Parámetros gestoría',
    'direccion-placas': 'Dirección por placas',
    contrasena: 'Contraseña',
    'clave-cotizador': 'Clave cotizador',
};

export const AdminShell = () => (
    <AppShell
        navGroups={ADMIN_NAV_GROUPS}
        allowedTypes={['1']}
        routeTitles={ADMIN_ROUTE_TITLES}
        checkPasswordExpiration
        logoHref="/"
        logoSrc={peicarLogo2vector}
    />
);

export default AdminShell;
